import { ButtonGroup } from '@wheely/ui-kit';
import cx from 'classnames';
import React from 'react';

import s from './styles.module.css';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

const BottomButtons = ({ children, className }: Props) => (
  <ButtonGroup data-test-id="bottom-buttons" className={cx(s.buttons, className)}>
    {children}
  </ButtonGroup>
);

export { BottomButtons };
